export const FETCH_TRACKING = 'tracking/FETCH';
export const FETCH_TRACKING_SUCCESS = 'tracking/FETCH_SUCESS';
export const FETCH_TRACKING_FAIL = 'tracking/FETCH_FAIL';

const initialState = {
  isLoading: false,
  requestCompleted: false,
  deliveryForecast: null,
  sku: null,
  statuses: [],
  urlTracking: null,
  trackingCode: null,
};

const initialAction = {};

const TrackingReducer = (state = initialState, action = initialAction) => {
  switch (action.type) {
    case FETCH_TRACKING:
      return {
        ...state,
        isLoading: true,
        requestCompleted: false,
      };
    case FETCH_TRACKING_SUCCESS:
      return {
        ...state,
        isLoading: false,
        requestCompleted: true,
        deliveryForecast: action.payload.deliveryForecast,
        sku: action.payload.sku,
        statuses: action.payload?.statuses,
        urlTracking: action.payload?.urlTracking,
        trackingCode: action.payload?.trackingCode,
      };
    case FETCH_TRACKING_FAIL:
      return {
        ...state,
        isLoading: false,
        requestCompleted: true,
        error: action.payload.error,
      };
    default:
      return { ...state };
  }
};

export default TrackingReducer;
